export default __webpack_public_path__ + "static/media/promomodalnhlbg.9b0bbcd3.png";